'use strict'

function initializeHeaderFlyout() {
  $(document).ready(function () {
    // Toggle Flyout
    $('.js-open-flyout').on('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      const flyoutBox = $('.flyout')
      const flyoutIndicator = $(this).data('flyout')
      const flyout = $('#' + flyoutIndicator)
      const header = $('.header')

      if ($('body').hasClass('no-overflow')) {
        $('body').removeClass('no-overflow')
      }

      if ($(flyout).hasClass('open')) {
        flyout.fadeOut(100, () => flyout.removeClass('open'))
        $('body').removeClass('no-overflow')
        setTimeout(function() {
          header.removeClass('flyout-open')
          header.removeClass('flyout-open--search')
        }, 90);
        $(this).removeClass('active')
      } else {
        $('body').addClass('no-overflow')
        header.addClass('flyout-open')
        if ($(this).hasClass('search-dd')) {
          header.addClass('flyout-open--search')
        }
        flyoutBox.fadeOut(100, () => flyoutBox.removeClass('open'))
        $('.js-open-flyout').removeClass('active')
        flyout.fadeIn(100, () => flyout.addClass('open'))
        $(this).addClass('active')
      }
    })

    // Close Flyout
    $('.js-close-flyout').on('click', function () {
      const flyoutBox = $('.flyout')
      const header = $('.header')
      flyoutBox.fadeOut(100, () => flyoutBox.removeClass('open'))
      $('body').removeClass('no-overflow')
      setTimeout(function() {
        header.removeClass('flyout-open')
        header.removeClass('flyout-open--search')
      }, 90);
      $('.js-open-flyout').removeClass('active')
      $('.navigation__flyout__level2-menu, .navigation__flyout__level3-menu').removeClass('active');
    })
  })
}

export default initializeHeaderFlyout
